import React from 'react'
import WrapperSection from '../../components/global/WrapperSection'
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import RolesTable from '../../components/Roles/RolesTable';

const Roles = () => {
    return (
        <>
            <WrapperSection>
                <GlobalBreadcrumbs />
                {/* data table Roles */}
                <RolesTable />
            </WrapperSection>
        </>
    )
}

export default Roles